/**
 * Используется в ситуациях когда необходимо false значение привести к undefined
 */
export function trueOrUndefined(value: boolean): true | undefined {
  return value === true ? true : undefined;
}
